/* global axios */
import ApiClient from '../ApiClient';

class CaptainResponses extends ApiClient {
  constructor() {
    super('captain/assistant_responses', { accountScoped: true });
  }

  get({ page = 1, search, assistantId, documentId, signal } = {}) {
    return axios.get(this.url, {
      params: {
        page,
        search,
        assistant_id: assistantId,
        document_id: documentId,
      },
      signal,
    });
  }

  syncTargets(assistantId, responseId) {
    return axios.get(`${this.url}/sync_targets`, {
      params: {
        assistant_id: assistantId,
        response_id: responseId,
      },
    });
  }
}

export default new CaptainResponses();
